import { getJSON } from '../../utils/request'

// Action Types
import {showExtendedModal} from "./uiReducer";

export const SET_SEARCH_URL = 'ticketsScanner/owners/SET_SEARCH_URL'
export const SEARCH_OWNERS_REQUEST = 'ticketsScanner/owners/SEARCH_OWNERS_REQUEST'
export const SEARCH_OWNERS_SUCCESS = 'ticketsScanner/owners/SEARCH_OWNERS_SUCCESS'
export const SEARCH_OWNERS_FAILURE = 'ticketsScanner/owners/SEARCH_OWNERS_FAILURE'
export const RESET_OWNERS_LIST = 'ticketsScanner/owners/RESET_OWNERS_LIST'
export const UPDATE_QUERY = 'ticketsScanner/owners/UPDATE_QUERY'

// Initial State
const initialState = {
  owners: {
    loaded: false,
    totalCount: 0,
    list: [],
  },
  searchURL: null,
  loading: false,
  error: null,
  currentRequest: null,
  query: ''
}

// Reducer
export default function ownersReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SEARCH_URL:
      return {
        ...state,
        searchURL: action.payload,
      }

    case SEARCH_OWNERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        currentRequest: action.payload,
      }

    case SEARCH_OWNERS_SUCCESS:
      return {
        ...state,
        loading: false,
        owners: action.payload,
        currentRequest: null,
      }

    case SEARCH_OWNERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        currentRequest: null,
      }

    case RESET_OWNERS_LIST:
      return {
        ...state,
        owners: {
          loaded: false,
          totalCount: 0,
          list: [],
        },
        loading: false,
        error: null,
      }

    case UPDATE_QUERY:
      return {
        ...state,
        query: action.payload,
      }

    default:
      return state
  }
}

// Action Creators
export const setSearchURL = (url) => ({
  type: SET_SEARCH_URL,
  payload: url,
})

export const resetOwnersList = () => ({
  type: RESET_OWNERS_LIST,
})

// Helper function
const isBarcodeString = (query) => /^\d{9}$/.test(query)

// Thunks
export const searchOwners = (query, limit = 10) => (dispatch, getState) => {
  const state = getState()
  const { searchURL, currentRequest } = state.ticketsScanner.owners

  // Abort the request still in flight: the scanner fires a search per keystroke, so a slower
  // earlier response must not be able to overwrite a later one.
  if (currentRequest) {
    currentRequest.abort()
  }

  const controller = new AbortController()

  dispatch({
    type: SEARCH_OWNERS_REQUEST,
    payload: controller,
  })

  return getJSON(searchURL, { query, limit }, { signal: controller.signal })
    .then((data) => {
      dispatch({
        type: SEARCH_OWNERS_SUCCESS,
        payload: {
          loaded: true,
          totalCount: data.total_count,
          list: data.list,
        },
      })
    })
    .catch((error) => {
      // An aborted request is this thunk superseding itself, not a failure to report.
      if (error.name === 'AbortError') return

      console.error(searchURL, error.message)
      dispatch({
        type: SEARCH_OWNERS_FAILURE,
        payload: error.message,
      })
    })
}

export const updateQuery = (query) => (dispatch) => {
  // Store the query in Redux state
  dispatch({
    type: UPDATE_QUERY,
    payload: query,
  })

  if (query.length < 3 || isBarcodeString(query)) {
    dispatch(resetOwnersList())
  } else {
    // Dispatch search with limit of 5
    dispatch(searchOwners(query, 5))
  }
}

export const forceSearch = (query) => (dispatch) => {
  if (query.length < 3 || isBarcodeString(query)) {
    return
  }

  dispatch(resetOwnersList())
  dispatch(searchOwners(query, 100))
  dispatch(showExtendedModal())
}

// Selectors
export const selectOwners = (state) => state.ticketsScanner?.owners?.owners || { loaded: false, list: [] }
export const selectSearchURL = (state) => state.ticketsScanner?.owners?.searchURL
export const selectOwnersLoading = (state) => state.ticketsScanner?.owners?.loading || false
export const selectOwnersError = (state) => state.ticketsScanner?.owners?.error
export const selectQuery = (state) => state.ticketsScanner?.owners?.query || ''
